/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiMatchType;
(function (ApiMatchType) {
    ApiMatchType["UNSPECIFIED"] = "MATCH_TYPE_UNSPECIFIED";
    ApiMatchType["BROAD"] = "MATCH_TYPE_BROAD";
    ApiMatchType["EXACT"] = "MATCH_TYPE_EXACT";
    ApiMatchType["PHRASE"] = "MATCH_TYPE_PHRASE";
})(ApiMatchType || (ApiMatchType = {}));
export function ApiMatchTypeFromJSON(json) {
    return ApiMatchTypeFromJSONTyped(json, false);
}
export function ApiMatchTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiMatchTypeToJSON(value) {
    return value;
}
